module.exports = __webpack_public_path__ + "Louis_de_Oliveira_Web_Over.jpg?fadfcc95979969e261717cbe81f97497";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/Louis_de_Oliveira_Web_Over.jpg
// module id = 170
// module chunks = 0